// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-dragging---wzlbi-w {\n  background: #fafafa;\n  border: 1px solid #ccc;\n}\n\n.row-dragging---wzlbi-w td {\n  padding: 10px 30px;\n}\n\n.row-dragging---wzlbi-w .drag-visible--25C13tiW {\n  visibility: visible;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row-dragging": "row-dragging---wzlbi-w",
	"drag-visible": "drag-visible--25C13tiW"
};
export default ___CSS_LOADER_EXPORT___;
